import { DisplayTime } from '@tock/time';
import { css } from '@emotion/react';

interface Props {
  expectedReservationTime?: string;
  status?: JSX.Element | 0 | ''; //TODO: Fix displayStatus type in partyUtil.tsx
}

const PartyPopoverDescription: React.FC<React.PropsWithChildren<Props>> = ({
  expectedReservationTime,
  status,
}) => {
  return expectedReservationTime ? (
    <div
      data-testid="party-popover-description"
      css={css`
        align-items: center;
        display: flex;
        justify-content: space-between;
        min-height: 3rem;
      `}
    >
      <span aria-label="Party Popover Description Time">
        {expectedReservationTime && <DisplayTime timeValue={expectedReservationTime} />}
      </span>
      <span aria-label="Party Popover Description Status">{status}</span>
    </div>
  ) : (
    <></>
  );
};

export default PartyPopoverDescription;
